import { render, staticRenderFns } from "./ArrivalGame.vue?vue&type=template&id=67a1c4a6&"
import script from "./ArrivalGame.vue?vue&type=script&lang=js&"
export * from "./ArrivalGame.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports